/**
 * Footer component - shared across the platform
 */
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p>© {currentYear} TestAuto.app - Test Automation Training Platform</p>
          <p className="footer-links">
            <span>Created by <a href="https://linkedin.com/in/pasimahonen" target="_blank" rel="noopener noreferrer">Pasi Mähönen</a></span>
            <span> | </span>
            <a href="https://github.com/pasi-mahonen/testauto-app" target="_blank" rel="noopener noreferrer">GitHub</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
